import type { ShortCircuitEvaluationRuleName } from '../..';
import type { ShortCircuitProperty } from '../../../../derived-state/gridElementsDetailsByCalculationType/shortCircuit/ShortCircuitProperty';
import type { AttentionStatusType } from '../../../AttentionStatus';
import type { ForStoringAttentionStatus2 } from '../../../AttentionStatusRepository';
import type { ForRuleProviding } from '../../../RulesProvider';
import type { ForFaultsEvaluation } from '../../ForFaultsEvaluation';
import { singleFaultEvaluation } from '../../singleElement/singleFaultEvaluation';
import type { ForShortCircuitEvaluation } from '../ForShortCircuitEvaluation';

export class FaultCurrentEvaluationEngine implements ForFaultsEvaluation {
  constructor(
    private readonly attentionStatusStorage: ForStoringAttentionStatus2,
    private readonly rulesProvider: ForRuleProviding
  ) {}

  evaluate1PhaseToGroundMax: ForShortCircuitEvaluation =
    shortCircuitProperty => {
      const ruleName: ShortCircuitEvaluationRuleName = 'Lv_Phase1Max';
      const evaluationRule = this.rulesProvider.getRule(ruleName);
      const evaluation = singleFaultEvaluation(
        evaluationRule,
        shortCircuitProperty.faultCurrent,
        ruleName,
        this.handleEvaluationEvent(shortCircuitProperty)
      );
      return evaluation;
    };

  evaluate1PhaseToGroundMin: ForShortCircuitEvaluation =
    shortCircuitProperty => {
      try {
        const ruleName: ShortCircuitEvaluationRuleName = 'Lv_Phase1Min';
        const evaluationRule = this.rulesProvider.getRule(ruleName);
        const evaluation = singleFaultEvaluation(
          evaluationRule,
          shortCircuitProperty.faultCurrent,
          ruleName,
          this.handleEvaluationEvent(shortCircuitProperty)
        );
        return evaluation;
      } catch (e) {
        console.log('error in evaluate1PhaseToGroundMin');
        console.log(shortCircuitProperty);
        console.log(e);
        throw e;
      }
    };

  evaluate2PhasesMin: ForShortCircuitEvaluation = shortCircuitProperty => {
    const ruleName: ShortCircuitEvaluationRuleName = 'Lv_Phase2Min';
    const evaluationRule = this.rulesProvider.getRule(ruleName);
    const evaluation = singleFaultEvaluation(
      evaluationRule,
      shortCircuitProperty.faultCurrent,
      ruleName,
      this.handleEvaluationEvent(shortCircuitProperty)
    );
    return evaluation;
  };

  evaluate3PhasesMax: ForShortCircuitEvaluation = shortCircuitProperty => {
    const ruleName: ShortCircuitEvaluationRuleName = 'Lv_Phase3Max';
    const evaluationRule = this.rulesProvider.getRule(ruleName);
    const evaluation = singleFaultEvaluation(
      evaluationRule,
      shortCircuitProperty.faultCurrent,
      ruleName,
      this.handleEvaluationEvent(shortCircuitProperty)
    );
    return evaluation;
  };

  private handleEvaluationEvent =
    (shortCircuitProperty: ShortCircuitProperty) =>
    (attentionStatus: AttentionStatusType) =>
      this.attentionStatusStorage.apply(
        shortCircuitProperty.gridElementId,
        shortCircuitProperty.name,
        attentionStatus
      );
}
